import { CookieConsent, useConsent } from '@silvertours/front-shared';
import { parseCookies } from 'nookies';

type UseABTestProps = {
  variantA: string;
  variantB: string;
}[];

const makeCookieName = (name: string): string => `featureToggles[${name}]`;

export function useABTest(tests: UseABTestProps): Record<string, boolean> {
  const consent = useConsent();

  if (consent !== CookieConsent.Enabled) {
    return {};
  }

  const cookies = parseCookies();

  return tests.reduce<Record<string, boolean>>(
    (acc, { variantA, variantB }) => {
      if (cookies[makeCookieName(variantA)] === 'true') {
        acc[variantA] = true;
      }

      if (cookies[makeCookieName(variantB)] === 'true') {
        acc[variantB] = true;
      }

      return acc;
    },
    {},
  );
}
